// @aurora/platform — aurora's binding to the shared engine.
//
// The engine itself lives in @platform/engine (repo ~/src/platform), shared with
// whisk and, later, codecast. This package stays as the name aurora imports so
// app code does not churn: it re-exports the engine surface unchanged, and is
// where any aurora-only addition to that surface would go.

export * from "@platform/engine";

/**
 * Fields only the server writes, per collection. A client may show them
 * optimistically (a retry flips a game to "making" at once), but it must never
 * hold a pending lock on them: the server writes its own value (its own
 * requested_at), the echo never matches, and a lock would freeze the field so
 * the game reads "making" forever. Both clients' registries mark these
 * `unprotectedFields` from this one list so they cannot drift.
 */
export const SERVER_OWNED_FIELDS = {
  artifacts: ['generation'],
} as const satisfies Record<string, readonly string[]>

export { followDelta, type FollowedPage } from "./follow";
